import React from 'react';
import { ProgressBarHolder, Progress } from './ProgressBar.styles';

export const ProgressBar: React.FunctionComponent<{progress: number}> = ({ progress }) => 
{
    return (
        <ProgressBarHolder>
            <Progress progress={progress}>
            </Progress>
        </ProgressBarHolder>
    );
};
